/**
 * HTML
 */
import '../auth-first.html'
import '../index.html'
import '../about.html'
import '../change-character.html'
import '../champions.html'
import '../game.html'

/**
 * Additional style
 */
import 'normalize.css'
import '../css/vendor/slick.css'
// import '../css/vendor/plyr.css'

/**
 * Project styles (POSTCSS)
 */
import '../css/style.p.css'

/**
 * Vendor scripts
 * jQuery импортируется в webpack.config.js
 */
import './vendor/jquery.validate.min.js'
import './vendor/timer.jquery.min.js'
import './vendor/jquery.imgpreload.min.js'
import './vendor/slick.js'
import './vendor/pleaserotate.min.js'



/**
 * Project scripts
 */

import './script.js'

/**
 * Inline style images
 */
import '../i/c/1.png'
import '../i/c/2.png'
import '../i/c/3.png'
import '../i/c/4.png'
import '../i/c/5.png'
import '../i/c/6.png'
import '../i/characters/1-big.png'
import '../i/characters/2-big.png'
import '../i/characters/3-big.png'
import '../i/characters/4-big.png'
import '../i/characters/5-big.png'
import '../i/characters/6-big.png'
import '../i/characters/arms-boys.png'
import '../i/characters/arms-girls.png'
import '../media/sound.mp3'
import '../media/sound.ogg'

import '../browserconfig.xml'
import '../mstile-150x150.png'
import '../apple-touch-icon.png'
import '../favicon.ico'
import '../android-chrome-256x256.png'
import '../android-chrome-192x192.png'
import '../safari-pinned-tab.svg'




// WEBPACK FOOTER //
// ./js/main.js